import React from 'react';
import PropTypes from 'prop-types';

import { App } from '@meronex/app';
import { CloseBtn, toast } from '@meronex/components';
import { useTheme } from '@material-ui/core/styles';

import StoreItemDetails from './StoreItemDetails';

import { storesMng } from '../../api/storesMng';
import { can, p } from '../../../common/roles';

function StoreItem(props) {
  let {
    item,

    onClick,
    onRemoveStoreItem,
    onRestoreStoreItem,
    showItemDetails,
    last,
    itemProducts,
    showBatches,
    onToggleActive,
  } = props;

  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  //TODO: refactor to remove it
  const permissions = {
    in: can(p.stores.itemIn),
    out: can(p.stores.itemOut),
    transfer: can(p.stores.transferItem),
    auditItem: can(p.stores.auditStore),
    restore: can(p.stores.itemRestore),
    delete: can(p.stores.itemDelete),
    modify: can(p.stores.modifyItemAmount),
    archive: can(p.stores.itemArchive),
    auditStore: can(p.stores.auditItem),
    CRUDItemTypes: can(p.stores.CRUDItemTypes),
    viewPrices: can(p.stores.viewStoresPrices),
  };

  const [openActions, setOpenActions] = React.useState();

  const _onClick = () => {
    setOpenActions(!openActions);
    onClick();
  };

  return (
    <>
      <div
        onClick={() => {
          _onClick();
        }}
        style={{
          padding: '12px 16px',
          cursor: 'pointer',
          transition: 'background-color 0.15s ease',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
        <StoreItemDetails
          item={item}
          permissions={permissions}
          prodcuts={itemProducts}
          showTransaction={false}
          showStore={false}
          showUpdated
          showDetails={showItemDetails}
          showBatches={showBatches}
          onToggleActive={onToggleActive}
        />
      </div>
      {!last && (
        <div
          style={{
            height: '1px',
            backgroundColor: isDark ? 'rgba(255,255,255,0.04)' : '#f1f5f9',
            marginLeft: '16px',
            marginRight: '16px',
          }}
        />
      )}
    </>
  );
}
StoreItem.propTypes = {
  item: PropTypes.object,
  itemProducts: PropTypes.array,
  onItemIn: PropTypes.func,
  onItemOut: PropTypes.func,
  onItemAudit: PropTypes.func,
  onDelete: PropTypes.func,
  onClick: PropTypes.func,
  onRemoveStoreItem: PropTypes.func,
  onRestoreStoreItem: PropTypes.func,
  expanded: PropTypes.bool,
  last: PropTypes.bool,
  permissions: PropTypes.object,
  onToggleActive: PropTypes.func,
};

StoreItem.defaultProps = {
  onDelete: () => {},
  onClick: () => {},
  onItemRestore: () => {},
  onItemRemove: () => {},
  onItemTransfer: () => {},
  onRemoveStoreItem: () => {},
  onRestoreStoreItem: () => {},
  onToggleActive: () => {},
};
export default StoreItem;
